import React from 'react'
import { translate } from '../../../common/i18n';

const CarouselTitle = () => (
    <div className="carousel-title">
        <div className="carousel-title__content">
            <h1>{translate('7 trading platforms — old favourites and new ones, too')}</h1>
        </div>
    </div>
);

export default CarouselTitle